<template>
	<div class="mb-4">
		<Error403></Error403>
	</div>
</template>

<script>
import Error403 from '@/components/Widgets/Errors/Error403.vue';
export default {
	name: '403',
	components: {
    Error403,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
